export const $address = Symbol('address');
export const $token = Symbol('token');
export const $tokens = Symbol('tokens');
export const $compiled = Symbol('compiled-token-assignment');
